// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"ab8751b9","413":"8d21d61f","453":"8f60e115","493":"8c81ffee","754":"4618dfe2","782":"08b61f04"}[chunkId] + ".chunk.js";
};